import { render, staticRenderFns } from "./select-classify.vue?vue&type=template&id=3b2dc9dc&scoped=true&"
import script from "./select-classify.vue?vue&type=script&lang=js&"
export * from "./select-classify.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b2dc9dc",
  null
  
)

export default component.exports